import React from 'react';

import { LoadableLazy } from '@confluence/loadable';

import { useIsStorageEnforcementEligible } from '../hooks/useIsStorageEnforcementEligible.ts';

const StorageEnforcementFlagsLoadable = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-StorageEnforcementFlagsLoadable" */ './StorageEnforcementFlags.tsx'
			)
		).StorageEnforcementFlags,
});

export const StorageEnforcementFlags = (): React.JSX.Element | null => {
	const isEligibleUser = useIsStorageEnforcementEligible();
	return isEligibleUser ? <StorageEnforcementFlagsLoadable /> : null;
};
